import { render } from "./hello.vue?vue&type=template&id=5a86f649&scoped=true"
import script from "./hello.vue?vue&type=script&lang=js"
export * from "./hello.vue?vue&type=script&lang=js"

import "./hello.vue?vue&type=style&index=0&id=5a86f649&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a86f649"]])

export default __exports__